import { COMPENSATION_TYPES, COMPENSATION_TYPE_LABELS } from "@aam/shared";
import { Label, Select } from "./ui";

/**
 * Advance vs as-earned for a new agent's contracts. The inviter chooses it with
 * the commission level, and both travel to the upline with the contract.
 */
export function CompensationTypeSelect({
  value,
  onChange,
  className,
}: {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}) {
  return (
    <Label className={className}>
      Advance or as earned
      <Select className="mt-1.5" value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="" disabled>
          Choose one
        </option>
        {COMPENSATION_TYPES.map((type) => (
          <option key={type} value={type}>
            {COMPENSATION_TYPE_LABELS[type]}
          </option>
        ))}
      </Select>
    </Label>
  );
}
